export const statusList = [
  { statusId: 0, statusName: 'Draft' },
  { statusId: 1, statusName: 'Submitted' },
  { statusId: 2, statusName: 'Converted' },
  { statusId: 3, statusName: 'Rejected' },
  { statusId: 4, statusName: 'Partly Converted' },
]

export const approvalStatusList = [
  { approvalStatusId: 0, approvalStatusName: 'Not Approved' },
  { approvalStatusId: 1, approvalStatusName: 'Lost' },
  { approvalStatusId: 2, approvalStatusName: 'Hold' },
  { approvalStatusId: 3, approvalStatusName: 'Rejected' },
  { approvalStatusId: 4, approvalStatusName: 'Won' },
]

export const discountTypeList = [
  { discountTypeValue: 0, discountTypeName: 'No Discount' },
  { discountTypeValue: 1, discountTypeName: 'Percent' },
  { discountTypeValue: 2, discountTypeName: 'Amount' },
]

export const DISCOUNT_TYPE_NA = 0
export const DISCOUNT_TYPE_PERCENT = 1
export const DISCOUNT_TYPE_AMOUNT = 2
export const DATE_FORMAT = 'YYYY-MM-DD'
export const FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const EUROPE_DATE_FORMAT = 'DD.MM.YYYY'
export const BIDDING_TYPE_AUTOMATIC = 1
export const BIDDING_TYPE_MANUAL = 2
export const SAVE_DIALOG_TYPE = 1
export const SAVE_AND_CLOSE_DIALOG_TYPE = 2
export const USER_TYPE_VENDOR = 0
export const USER_TYPE_COMPANY = 1
export const CONDITION_TYPE_NEW = 3
export const BID_STATUS_DRAFT = 'Draft'
